import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import AGB from "@/pages/AGB";
import { AdminLogin, AdminDashboard, AdminBlogEditor } from "@/pages/Admin";
import { AuthProvider } from "@/contexts/AuthContext";
import WhatsAppButton from "@/components/solanova/WhatsAppButton";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/blog/new" element={<AdminBlogEditor />} />
            <Route path="/admin/blog/edit/:slug" element={<AdminBlogEditor />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <WhatsAppButton />
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#111",
            border: "1px solid rgba(200,162,122,0.3)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
